import { useState, useEffect } from 'react';
import Axios from "axios";
import { ChangeUserStatus, GetListOfUsersByEmployeeID } from '../apiconstants/constants';
import { Link, useLocation } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import Swal from 'sweetalert2';
import { useCountry } from '../contexts/countrycodecontext.js';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ListOfUsers = () => {
    const { countryCodes, selectedCountry, setSelectedCountry } = useCountry();
  
  const [offset, setOffset] = useState(0);
  let query = useQuery();
  const guid = localStorage.getItem("guid");
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
const token = localStorage.getItem("jwtToken");
  const roleMapping = {
    3: 'User',
    4: 'Cem',
    
  };
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };

  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };

  const GetCandidateList = () => {
    setIsLoading(true);

    const GetapiUrl = GetListOfUsersByEmployeeID.APIURL + `?EmployeeGuid=${guid}`;

    Axios.get(GetapiUrl, { headers: { Authorization: `Bearer ${token}` } })
      .then((result) => {
        setIsLoading(false);
        setCandidateData(result.data);
      }).catch((error) => {
        console.log("Error" + error);
      });
  };

  const handleUserStatus = (guid, isActive) => {
    // Determine the type based on the isActive state
    const newIsActive = !isActive;
    const type = newIsActive ? 1 : 0;
    // Construct the API URL with correct query parameters
    const APIURL = `${ChangeUserStatus.APIURL}?Guid=${guid}&type=${type}`;

    setIsLoading(true); // Set loading state before API call

 Axios.put(
  APIURL,
  {}, // empty body
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
)

        .then((result) => {
            // Handle the success response here
            setCandidateData(prevData => 
                prevData.map(candidate => 
                    candidate.guid === guid ? { ...candidate, isActive: newIsActive } : candidate
                )
            );

            setIsLoading(false); // Set loading state to false after state update

            if (result.data.message === "User Activated successfully.") {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Activated Successfully',
                    showConfirmButton: false,
                    timer: 5000,
                });
            } else if (result.data.message === "User Deactivated successfully.") {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Deactivated Successfully',
                    showConfirmButton: false,
                    timer: 5000,
                });
            }
        }).catch((error) => {
            console.log("Error: " + error);
            setIsLoading(false); // Set loading state to false in case of error
        });
  };

  useEffect(() => {
    GetCandidateList();
  }, []); // Fetch data only once when the component mounts

  useEffect(() => {
    const filteredData = candidateData.filter(candidate =>
      candidate?.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      candidate?.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const slice = filteredData.slice(offset, offset + perPage);
    const items = viewType === 'grid' ? slice.map((data) => {
      return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guid}>
          <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 300, height: 300, borderRadius: 20 }}>
            <div className='card-header' style={{ background: "none", minHeight: 140 }}>
              <div className='row'>
                <div className='col-8'>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Name</Tooltip>)}>
                    <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.firstName} {data.lastName}</b></p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                  <p className="text-para"  style={{ fontSize: 14}}>
           
           <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} className="fa fa-envelope" aria-hidden="true"></i>{data.email}
      
           </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip"  {...props}><span className="tooltip2">Mobile Number</span></Tooltip>)}>
                     <p className="text-para"  style={{ fontSize: 14}}>
           
                <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} className="fas fa-mobile" aria-hidden="true"></i>{data.mobileNumber}
           
                </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip"  {...props}><span className="tooltip2">Role</span></Tooltip>)}>
                    {/* <p className="text-para"> {roleMapping[data.roleID] }  </p> */}
                    <p className="text-para"  style={{ fontSize: 14}}>
           
                <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} className="fa fa-user-tag" aria-hidden="true"></i>{roleMapping[data.roleID]}
           
                </p>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            <div className='card-footer d-flex justify-content-between' style={{ background: "none" }}>
                <Link to={"/Employer/EditUser?guid=" + data.guid}>
 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Edit</Tooltip>)}>
    <button style={{ background: "none", border: "none" }}>
    <i className="fa fa-edit mt-1" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
     </button>
                                      </OverlayTrigger>
                                                               </Link>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {data.isActive ? 'Deactivate User' : 'Activate User'}</Tooltip>)}>
                <button onClick={() => handleUserStatus(data.guid, data.isActive)} style={{ background: "none", border: "none" }}>
                  <i className={`fa fa-${data.isActive ? 'toggle-on' : 'toggle-off'}`} aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i>
                </button>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      )
    }) :

    <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
        <table className="table" 
  style={{
    minWidth: "100%",
    fontSize: "12px", // Reduced font size
    // tableLayout: "fixed",
    wordWrap: "break-word",
  }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile Number</th>
              <th>Role</th>
              <th>Actions</th>
              </tr>
          </thead>
          <tbody>
            {slice?.map((data, index) => {
  
              return(
              <tr key={index}>
                <td>{data.firstName} {data.lastName}</td>
                <td>{data.email}</td>
                <td>{data.mobileNumber}</td>
                <td>{data.roleID}</td>
            
                <td> <div style={{ display: "flex", gap: "5px", alignItems: "center" }}> 
                         
              <Link to={"/Employer/EditUser?guid=" + data.guid}>
 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Edit</Tooltip>)}>
    <button style={{ background: "none", border: "none" }}>
    <i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i>
     </button>
                                      </OverlayTrigger>
                                          </Link>
                                          <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {data.isActive ? 'Deactivate User' : 'Activate User'}</Tooltip>)}>
                <button onClick={() => handleUserStatus(data.guid, data.isActive)} style={{ background: "none", border: "none" }}>
                  <i className={`fa fa-${data.isActive ? 'toggle-on' : 'toggle-off'}`} aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i>
                </button>
              </OverlayTrigger>  
                                      </div></td>
               
               </tr>
      )} )
           }
          </tbody>
        </table>
       </div>

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm, candidateData, perPage,viewType]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes to show results from the first page
  };

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
        <div className="responsive-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div> <h2 className="" style={{ color: "#00a7ac" }}>List of Users</h2></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <input
                id="searchvendor"
                type="text"
                placeholder="Search by Name or Email"
                className="form-control"
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
            {showIcon === 'grid' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                    <button
                      className="btn btn-primary mr-3"
                      onClick={() => handleViewToggle('list')}
                      style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                      <i className="fa fa-th-list" style={{ color: '#fff', fontSize: "16px" }}></i>
                    </button>
                  </OverlayTrigger>
                )}
              
                {showIcon === 'list' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                    <button
                      className="btn btn-primary mr-3"
                      onClick={() => handleViewToggle('grid')}
                      style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                      <i className="fa fa-th" style={{ color: '#fff', fontSize: "16px" }}></i>
                    </button>
                  </OverlayTrigger>
                )}
            <div>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Add User</Tooltip>)}>
                <Link to="/Employer/AddUser">
                  <button className="btn btn-primary mr-3" btn-type="button"><i className="fa fa-plus"></i></button>
                </Link>
              </OverlayTrigger>
            </div>
          </div>
        </div>
        <hr />

       <div className="row mt-5 pb-3">
          {isLoading ? <center><LoadingSpinner /></center> : <> {data}</>}
        </div>
        {candidateData.length === 0 || data.length === 0 && (
          <div className="pb-5 text-center">
            <img title='No Data' alt='no-data-img' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
          </div>
        )}
        {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }
      </div>
    </ConsultantLayout>
  );
}

export default ListOfUsers;
